import { render, staticRenderFns } from "./ChangelogPage.vue?vue&type=template&id=b8368dda"
import script from "./ChangelogPage.vue?vue&type=script&lang=js"
export * from "./ChangelogPage.vue?vue&type=script&lang=js"
import style0 from "./ChangelogPage.vue?vue&type=style&index=0&id=b8368dda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports